import React from 'react';
import { dateWordCard } from 'helper/helper';

/**
 * One row of a mission list, in either slide-over: the temp worker's missions,
 * candidatures and unassignments, and the company's missions. They all read the
 * same — no icon, the state lives in the badge — so they share this card.
 *
 * `badge` is capped in width and truncates: a refusal reason runs long and must
 * not eat into the title.
 */
const MissionListCard = ({
  title,
  idMission,
  subtitle,
  duration,
  badge,
  onClick,
  children,
}) => (
  <div
    data-mission-card
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.();
      }
    }}
    className={
      'bg-white border border-[#efefef] rounded-md p-3 mb-3 cursor-pointer transition-colors duration-150 hover:bg-gray-50 active:bg-gray-100'
    }
  >
    <div className={'flex justify-between gap-3'}>
      <div className={'flex flex-col gap-1 flex-1 min-w-0'}>
        <div className={'flex items-center gap-2 flex-wrap'}>
          <span className={'font-medium text-gray-900'}>{title}</span>
          {idMission && <span className={'text-gray-400'}>n°{idMission}</span>}
        </div>
        {subtitle && <div className={'text-gray-500 text-sm'}>{subtitle}</div>}
      </div>
      <div className={'flex flex-col items-end gap-1 flex-shrink-0'}>
        {badge && (
          <div data-card-badge className={'max-w-[150px]'}>
            {badge}
          </div>
        )}
        {duration?.datestart && duration?.dateend && (
          <div className={'text-gray-400 text-xs text-right whitespace-nowrap'}>
            {dateWordCard(duration.datestart)} {'>'} {dateWordCard(duration.dateend)}
          </div>
        )}
      </div>
    </div>
    {children}
  </div>
);

export default MissionListCard;
